import React from 'react';
import { TextButton } from 'wix-ui-tpa/cssVars';
import { st, classes } from './LoadAllButton.st.css';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';
import settingsParams from '../../../settingsParams';

export type LoadAllButtonProps = {
  onClick;
};
export const LoadAllButton = ({ onClick }: LoadAllButtonProps) => {
  const settings = useSettings();
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const showDefaultValue = experiments.enabled(
    'specs.bookings.showDefaultValue',
  );

  return (
    <TextButton
      className={st(classes.root, { isMobile })}
      onClick={onClick}
      data-hook="load-all-button"
    >
      {showDefaultValue
        ? settings.get(settingsParams.scheduleLoadAllText) ||
          settings.getDefaultValue(settingsParams.scheduleLoadAllText)
        : settings.get(settingsParams.scheduleLoadAllText)}
    </TextButton>
  );
};
